import ShopThisPostCard from 'components/Community/ShopThisPostCard/ShopThisPostCard';
import { withShopThisPostCardProps } from 'viewModel/gallery/withShopThisPostCardProps';

const ConnectedShopThisPostCard = withShopThisPostCardProps(ShopThisPostCard);

export default ConnectedShopThisPostCard;
